export const MultiSelectStrings = {
  allItemsAreSelected: 'Todos os itens foram selecionados.',
  clearSearch: 'Limpar busca',
  clearSelected: 'Limpar seleção',
  noOptions: 'Não há opções',
  search: 'Buscar',
  selectAll: 'Selecionar todos',
  selectAllFiltered: 'Selecionar todos os filtrados',
  selectSomeItems: 'Selecione...',
  create: 'Criar',
};
